import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function NotificationBell() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((i) => !i.read).length;
  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <DropdownMenu onOpenChange={(o) => o && unread && markAll()}>
      <DropdownMenuTrigger asChild>
        <button data-testid="notification-bell" className="relative p-2 rounded-lg hover:bg-white/10 text-white/90 transition-colors">
          <Bell className="w-5 h-5" />
          {unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 bg-sunburst text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto p-0">
        <div className="px-4 py-3 border-b font-display font-semibold text-slate-800">Notifications</div>
        {items.length === 0 && <p className="px-4 py-8 text-center text-sm text-slate-400">No notifications yet</p>}
        {items.map((n) => (
          <div key={n.id} className={`px-4 py-3 border-b last:border-0 text-sm ${n.read ? "text-slate-500" : "text-slate-800 bg-orange-50/40"}`}>
            <p>{n.message}</p>
            <p className="text-xs text-slate-400 font-mono mt-1">{new Date(n.created_at).toLocaleString()}</p>
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
